import React, {Component} from "react";
import {ReactComponent as LogoIcon} from "../../img/logo.svg";
import {ReactComponent as SearchIcon} from "../../img/search.svg";
import {inject} from "mobx-react";
import * as EditIcon from "./EditIcon.png";
import { translate } from "../../dictionaries";
import {ReactComponent as China} from '../../img/china_flag.svg';
import {ReactComponent as Rus} from '../../img/rus_flag.svg';
import {ReactComponent as Eng} from '../../img/eng.svg';

@inject(stores => ({
        AuthorizationStore: stores.rootStore.Authorization,
    })
)

class Menu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: "",
            isShowMobile: false,
            phone: false
        };
    }

    componentDidMount() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({
                phone: true
            })
          } else {
            this.setState({
                phone: false
            })
        }
    }

    updateMobileVisibility = () => {
        this.setState({
            isShowMobile: !this.state.isShowMobile
        })
    };

    onChangeSearch = (e) => {
        this.setState({
            search: e.currentTarget.value
        })
    };

    search = () => {
        window.location.href = `${window.location.origin}/search?query=${this.state.search}`
    };

    renderItems = (items, isRoot) => {
        return items.map((item) => {
            return (
                <li className={!!isRoot ? "nav__item" : ""}>
                    <div style={{display: "flex"}}>
                        {
                            (!!this.props.AuthorizationStore.token && !this.props.editable) &&
                            <>
                                {
                                    (!!isRoot && item.id !== 1) &&
                                    <img
                                        onClick={
                                            () => {
                                                this.props.edit(item.id)
                                            }
                                        }
                                        style={{
                                            cursor: "pointer",
                                            width: 25,
                                            height: 25,
                                            marginRight: 10,
                                            marginTop: 12
                                        }}
                                        src={EditIcon}/>
                                }
                                {
                                    (!isRoot && item.id !== 1) &&
                                    <img
                                        onClick={
                                            () => {
                                                this.props.edit(item.id)
                                            }
                                        }
                                        style={{
                                            cursor: "pointer",
                                            width: 25,
                                            height: 25,
                                            marginRight: 10,
                                            marginTop: -5
                                        }}
                                        src={EditIcon}/>
                                }
                            </>
                        }
                        {
                            item.isRoot &&
                            <a style={!!item.color ? {
                                cursor: "default",
                                color: `${item.color}`
                            } : {cursor: "default"}}
                               className={!!isRoot ? "nav__link" : ""}>
                                {
                                    (localStorage.getItem('language') === 'ru' || !localStorage.getItem('language')) && item.russianName
                                }
                                {
                                    localStorage.getItem('language') === 'en' && item.englishName
                                }
                                {
                                    localStorage.getItem('language') === 'zh' && item.chinaName
                                }
                            </a>
                        }
                        {
                            !item.isRoot &&
                            <a href={"/" + item.href} style={!!item.color ? {
                                cursor: "default",
                                color: `${item.color}`
                            } : {cursor: "default"}}
                               className={!!isRoot ? "nav__link" : ""}>
                                {
                                    (!localStorage.getItem('language') || localStorage.getItem('language') === 'ru') && item.russianName
                                }
                                {
                                    localStorage.getItem('language') === 'en' && item.englishName
                                }
                                {
                                    localStorage.getItem('language') === 'zh' && item.chinaName
                                }
                            </a>
                        }

                    </div>
                    {
                        <ul className="nav__items">
                            {
                                (!!this.props.AuthorizationStore.token && !item.isEdit && !this.props.editable) &&
                                <li className={!!isRoot ? "nav__link" : ""}>
                                    <a onClick={() => {
                                        this.props.addChildMenu(item.id)
                                    }} style={{cursor: "pointer"}}>{translate('common.add2')}</a>
                                </li>
                            }
                            {this.renderItems(item.items)}
                        </ul>
                    }
                </li>
            )
        })
    };

    render() {
        return (
            <div className="site__nav" style={{marginTop: this.props.showBanner && !this.state.phone ? 60 : 0}}>
                <aside className="nav">
                    <a className="nav__logo" href="/">
                        <LogoIcon className={"logo_icon"}/>
                        <span>{translate('common.faq2')}</span>
                    </a>
                    {
                        !/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) &&
                        <p style={{display: 'flex', columnGap: 8, marginRight: 10}}>
                            {
                                    !!localStorage.getItem('language') && localStorage.getItem('language') !== 'ru' && (
                                    <span
                                        style={{cursor: 'pointer'}} 
                                        onClick={() => {
                                            localStorage.setItem('language', 'ru');
                                            window.location.replace(window.location.origin + window.location.pathname);
                                        }}
                                    >
                                        <Rus />
                                    </span>
                                )
                            }
                            {
                                localStorage.getItem('language') !== 'en' && (
                                    <span 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        localStorage.setItem('language', 'en');
                                        window.location.replace(window.location.origin + window.location.pathname);
                                    }}>
                                        <Eng />
                                    </span>
                                )
                            }
                            {
                                localStorage.getItem('language') !== 'zh' && (
                                    <span 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        localStorage.setItem('language', 'zh');
                                        window.location.replace(window.location.origin + window.location.pathname);
                                    }}>
                                        <China />
                                    </span>
                                )
                            }
                        </p>
                    }
                    <form onSubmit={(e) => e.preventDefault()} className="nav__search">
                        <input value={this.state.search} onChange={this.onChangeSearch} type="text"
                               className="input nav__input-search" name="search" placeholder={translate('common.quantion')}/>
                        <button onClick={this.search} type="submit"
                                className="nav__btn-search"
                        >
                            <SearchIcon/>
                        </button>
                    </form>
                    {
                        /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) &&
                        <p style={{display: 'flex', columnGap: 8}}>
                            {
                                    !!localStorage.getItem('language') && localStorage.getItem('language') !== 'ru' && (
                                    <span
                                        style={{cursor: 'pointer'}} 
                                        onClick={() => {
                                            localStorage.setItem('language', 'ru');
                                            window.location.replace(window.location.origin + window.location.pathname);
                                        }}
                                    >
                                        <Rus />
                                    </span>
                                )
                            }
                            {
                                localStorage.getItem('language') !== 'en' && (
                                    <span 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        localStorage.setItem('language', 'en');
                                        window.location.replace(window.location.origin + window.location.pathname);
                                    }}>
                                        <Eng />
                                    </span>
                                )
                            }
                            {
                                localStorage.getItem('language') !== 'zh' && (
                                    <span 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        localStorage.setItem('language', 'zh');
                                        window.location.replace(window.location.origin + window.location.pathname);
                                    }}>
                                        <China />
                                    </span>
                                )
                            }
                        </p>
                    }
                    <button onClick={this.updateMobileVisibility} type="button"
                            className={this.state.isShowMobile ? "nav__burger nav__burger--active" : "nav__burger"}
                    ></button>
                    <ul className={this.state.isShowMobile ? "nav__list nav__list--active" : "nav__list"}>
                        {
                            !!this.props.AuthorizationStore.token &&
                            <>
                                <li className="nav__item">
                                    <a onClick={() => {
                                        this.props.AuthorizationStore.setAuthorize(false, null);
                                        window.setTimeout(() => {
                                            window.location.reload();
                                        }, 0);
                                    }}
                                       style={{cursor: "pointer"}}
                                       className="nav__link">{translate('common.exit')}</a>
                                </li>
                                <li className="nav__item">
                                    <a onClick={this.props.addRootMenu} style={{cursor: "pointer"}}
                                       className="nav__link">{translate('common.add')}</a>
                                </li>
                            </>
                        }
                        {
                            this.renderItems(this.props.menu, true)
                        }
                    </ul>
                </aside>
            </div>
        )
    }
};

export default Menu